import { Modal, ModalBody } from "shared/UI/Modal/Modal";
import { t } from "i18next";
import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { IntegerInput } from "shared/UI/Inputs/IntegerInput/IntegerInput";

export interface SetGoalModalProps {
  heading: string;
  description: string;
  currentGoal: number;
  unit: string;
  incrementStep: number;
  onClose: Function;
  onSave: Function;
}

export const SetGoalModal = ({ heading, description, currentGoal, unit, incrementStep, onClose, onSave }: SetGoalModalProps) => {
  const [goal, setGoal] = useState(currentGoal);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSave(goal);
    }
  };

  return (
    <Modal width="xs" close={() => onClose()}>
      <ModalBody>
        <div className="flex flex-col gap-4">
          <h2>{heading}</h2>
          <IntegerInput
            aria-label={t("wellbeing.trackers.goal.ariaInput")}
            onChange={(e) => setGoal(parseInt(e.target.value))}
            step={incrementStep}
            value={String(goal)}
            onKeyDown={handleKeyPress}
            min={1}
            maxLength={8}
            suffix={unit}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
          <p role="note">{description}</p>
          <Button text={t("wellbeing.trackers.buttons.save")} onClick={() => onSave(goal)} disabled={goal === 0} />
          <Button variant="text" text={t("wellbeing.trackers.buttons.back")} onClick={() => onClose()} />
        </div>
      </ModalBody>
    </Modal>
  );
};
